import { default as jQuery } from 'jquery';

globalThis.jQuery = jQuery;
globalThis.$ = jQuery;

if (process.env.NODE_ENV === 'production' ) {
    require(`jquery-migrate/dist/jquery-migrate.min.js`)
} else {
    require(`jquery-migrate/dist/jquery-migrate.js`)
}

require("jquery-validation/jquery.validate.js")
require("jquery.event.drag/jquery.event.drag.js")
require("jquery.event.drop/jquery.event.drop.js")
require("./custom/jquery/jquery.solovis.floating-hscroll.js")
require("jquery-file-download/index.js")
window.JSZip = require("jszip/dist/jszip.min.js")